import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { isSameMonth } from "../../utils/dateUtils";


const StatistiqueEnvoiMailMois = ({ facturations, selectedMonth }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const calculatePercentages = () => {
      const [selectedYear, selectedMonthNum] = selectedMonth.split("-").map(Number);
  
      const facturationsInSelectedMonth = facturations.filter(fact =>
        isSameMonth(fact.mois_facturation, selectedMonth)
      );
  
      const dateRanges = [
        { start: 1, end: 15, monthOffset: 0 },
        { start: 16, end: new Date(selectedYear, selectedMonthNum, 0).getDate(), monthOffset: 0 },
        { start: 1, end: 15, monthOffset: 1 },
        { start: 16, end: new Date(selectedYear, selectedMonthNum, 0).getDate(), monthOffset: 1 }
      ];
  
      const totals = dateRanges.map(range => {
        const start = new Date(selectedYear, selectedMonthNum - 1 + range.monthOffset, range.start);
        const end = new Date(selectedYear, selectedMonthNum - 1 + range.monthOffset, range.end);
  
        const count = facturationsInSelectedMonth.filter(fact => {
          const dateEnvoi = new Date(fact.date_envoi_mail);
          return dateEnvoi >= start && dateEnvoi <= end;
        }).length;
  
        const percentage = Math.round((count / facturationsInSelectedMonth.length) * 100);
  
        const formattedMonth = String(start.getMonth() + 1).padStart(2, '0');
        const formattedDate = `${String(range.start).padStart(2, '0')} au ${String(range.end).padStart(2, '0')}/${formattedMonth}`;
  
        return { date: formattedDate, percentage };
      });
  
      setData(totals);
    };
  
    if (facturations.length > 0) {
      calculatePercentages();
    }
  }, [selectedMonth, facturations]);
  
  

// Couleurs assignées à chaque période
  const COLORS = ['#086532', '#045674', '#FFBB28', '#FF8042'];
  return (
    <div className="container-statistique-statut">
      <h2 className="title-statiquestatut">Date d’envoi des factures</h2>
      <ResponsiveContainer width="100%" height={340}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip formatter={(value) => `${value}%`} />
          <Bar
            dataKey="percentage"
            fill="#8884d8"
            label={{
              position: 'top',
              formatter: (value) => `${value}%`, // Format the label with percentage sign
            }}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StatistiqueEnvoiMailMois;
